import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ASSET_URL } from '../config/config';



const SlickSliderGallery = () => {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,              
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };
      return (
        <Slider {...settings}>
          <div>
            <div className='product-image'>
                <img src={ASSET_URL+'assets/images/gallery/1.webp'} className="w-100 d-block" alt="Banner"/>
            </div>
          </div>
          <div>
            <div className='product-image'>
                <img src={ASSET_URL+'assets/images/gallery/2.webp'} className="w-100 d-block" alt="Banner"/>
            </div>
          </div>
          <div>
            <div className='product-image'>
                <img src={ASSET_URL+'assets/images/gallery/3.webp'} className="w-100 d-block" alt="Banner"/>
            </div>
          </div>
          
        </Slider>
      );
}

export default SlickSliderGallery